import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { BoxReportListComponent } from './box-report-list/box-report-list.component';
import { FileListComponent } from './file-list/file-list.component';

const routes: Routes = [
  {
    path: '',
    component: BoxReportListComponent,
  },
  {
    path: 'registered-user',
    component: FileListComponent,
  },
  {
    path: 'last-active-user',
    component: FileListComponent,
  },
  {
    path: 'csr-report',
    component: FileListComponent,
  },
  {
    path: 'analytics-report',
    component: FileListComponent,
  },

  { path: '', pathMatch: 'full', redirectTo: 'catalog/reports' },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportsRoutingModule { }
